import { render, staticRenderFns } from "./BoxPerformanceComparisonRadarDistricts.vue?vue&type=template&id=415e77b4&scoped=true&"
import script from "./BoxPerformanceComparisonRadarDistricts.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonRadarDistricts.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonRadarDistricts.vue?vue&type=style&index=0&id=415e77b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415e77b4",
  null
  
)

export default component.exports
import {QCard,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable})
